import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import moment from 'moment';
import { getInitTime } from './utils';
import { taskType } from '@/pages/LogisticsManage/LogisticsDispatch/constants';
import { getUrlParam } from '@/utils/url';

const initTime = getInitTime();

const initialOrderParams = {
  shopName: null,
  companyId: null,
  groupOrderId: null,
  companyAddressIdList: [''],
  deliveryDay: moment(),
  deliveryBeginTime: initTime[0],
  deliveryEndTime: initTime[1],
  status: '50',
  pageSize: 50,
  page: 1,
  dispatchType: '0',
  taskType: -1,
};

const model = {
  state: {
    distributionUnitList: [],
    distributionUnitId: null,
    companyList: [],
    addressList: [],
    orderParams: initialOrderParams,
    orderStatus: {
      readySend: 0,
      readyGet: 0,
      riderGet: 0,
      arrive: 0,
      cancelCount: 0,
    },
    orderList: [],
    orderListLoading: false,
    orderListTotal: 0,
    detailModalVisible: false,
    detailLoading: false,
    detailGroupOrderId: null,
    detailData: {
      groupOrder: {},
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
    },
    riderParams: {
      name: null,
      pageSize: 10,
      page: 1,
    },
    riderList: [],
    riderListLoading: false,
    riderListTotal: 0,
    riderDesertion: [], // 离岗人员
    groupOrderIds: [], // 选定订单
    employeeId: null, // 选定骑手
    allRiderList: [], // 改派时，商圈全部骑手
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { logisticsDispatch }, getState }) => ({
    // 获取配送单元列表
    async getDistributionUnitList(distributionUnitName = '') {
      const data = await fetch('/saasmerchant/fsarea/distribution/unit/base/authority/sortList', {
        params: {
          distributionUnitName, // 生效
        },
      });
      const { id } = getUrlParam();

      if (data?.list) {
        const distributionUnitList = data.list.map((d) => ({
          id: d.distributionUnitId,
          label: d.distributionUnitName,
          value: d.distributionUnitId,
        }));
        logisticsDispatch.setState({ distributionUnitList });
        // 默认选择第一个
        if (distributionUnitList.length > 0) {
          logisticsDispatch.setState({
            distributionUnitId: id ? Number(id) : distributionUnitList[0].id,
          });
        }
      }
    },
    // 选择配送单元
    setDistributionUnit(distributionUnitId) {
      logisticsDispatch.setState({ distributionUnitId });
    },
    async getCompanyList(addressType) {
      const { distributionUnitId } = getState().logisticsDispatch;
      const data = await fetch('/saasmerchant/fsarea/logistics/getCompanyLists', {
        params: { distributionUnitId, addressType },
      });
      if (data) {
        const companyList = data.map((d) => ({
          id: d.companyId,
          key: d.companyId,
          label: d.companyName,
          content: d.companyName,
        }));
        logisticsDispatch.setState({ companyList });
      }
    },
    async getAddressList(companyId) {
      const data = await fetch('/saasmerchant/fsarea/logistics/getCompanyAddress', {
        params: { companyId },
      });
      if (data) {
        const addressList = [
          {
            title: '全部',
            value: '',
            key: '',
            children: data.map((d) => ({
              title: d.adderss,
              value: d.companyAddressId,
              key: d.companyAddressId,
              content: d.adderss,
            })),
          },
        ];
        logisticsDispatch.setState({ addressList });
      }
    },
    clearAddressList() {
      logisticsDispatch.setState({
        addressList: [
          {
            title: '全部',
            value: '',
            key: '',
          },
        ],
      });
    },
    // 获取物流聚单列表
    async getOrderList() {
      logisticsDispatch.setState({ orderListLoading: true });
      const { orderParams, distributionUnitId, dispatchType } = getState().logisticsDispatch;
      if (distributionUnitId) {
        const params = { ...orderParams };
        params.deliveryDay = moment(orderParams.deliveryDay.startOf('days')).format(
          'YYYY-MM-DD HH:mm:ss',
        );
        params.deliveryBeginTime = orderParams.deliveryBeginTime.format('HH:mm');
        params.deliveryEndTime = orderParams.deliveryEndTime.format('HH:mm');

        const data = await fetch('/saasmerchant/fsarea/logistics/getgrouporderlist', {
          params: filterNull({
            ...params,
            distributionUnitId,
            status: Number(params.status),
            dispatchType,
          }),
          type: 'POST',
          useJson: true,
        });
        if (data) {
          logisticsDispatch.setState({
            orderList: data.groupOrderListVos || [],
            orderListTotal: data.total || 0,
            orderStatus: {
              readySend: data.countVo.readySend,
              readyGet: data.countVo.readyGet,
              riderGet: data.countVo.riderGet,
              arrive: data.countVo.arrive,
              cancelCount: data.countVo.cancelCount,
            },
          });
        }
      }
      logisticsDispatch.setState({ orderListLoading: false });
    },
    // 搜索
    onSearch(orderParams) {
      logisticsDispatch.setState({ orderParams });
    },
    // 底部换页
    onNav(page) {
      const { orderParams } = getState().logisticsDispatch;
      logisticsDispatch.setState({ orderParams: { ...orderParams, page } });
    },
    // 重置筛选项
    onReset() {
      logisticsDispatch.setState({
        orderParams: initialOrderParams,
      });
    },
    onTabsChange(status) {
      const { orderParams } = getState().logisticsDispatch;
      logisticsDispatch.setState({
        orderParams: {
          ...orderParams,
          page: 1,
          status,
        },
      });
    },
    ondispathChange(dispatchType) {
      logisticsDispatch.setState({
        dispatchType,
      });
    },
    // 弹窗
    async setDetailModalVisible(visible, groupOrderId) {
      const { detailData } = getState().logisticsDispatch;
      logisticsDispatch.setState({ detailModalVisible: visible });
      if (visible === true) {
        logisticsDispatch.setState({ detailLoading: true, detailGroupOrderId: groupOrderId });
        const data = await fetch('/saasmerchant/fsarea/logistics/getgrouporderdetail', {
          type: 'GET',
          params: {
            groupOrderId,
            page: detailData.page,
            pageSize: detailData.pageSize,
          },
        });
        logisticsDispatch.setState({ detailLoading: false });
        if (data) {
          logisticsDispatch.setState({
            detailData: {
              ...detailData,
              taskInfo: data.taskInfo,
              businessTransitPoint: data.businessTransitPoint,
              groupOrder: data.groupOrder,
              list: data.orderDetailVos,
              total: data.total,
            },
          });
        }
      } else {
        logisticsDispatch.setState({
          detailData: {
            groupOrder: {},
            orderDetailVos: [],
            page: 1,
            pageSize: 10,
            total: 0,
          },
        });
      }
    },
    async onDetailNav(page) {
      const { detailGroupOrderId, detailData } = getState().logisticsDispatch;
      const data = await fetch('/saasmerchant/fsarea/logistics/getgrouporderdetail', {
        type: 'GET',
        params: {
          groupOrderId: detailGroupOrderId,
          page,
          pageSize: detailData.pageSize,
        },
      });
      if (data) {
        logisticsDispatch.setState({
          detailData: {
            ...detailData,
            groupOrder: data.groupOrder,
            list: data.orderDetailVos,
            page,
            total: data.total,
          },
        });
      }
    },
    // 获取骑手列表
    async getRiderList() {
      logisticsDispatch.setState({ riderListLoading: true });
      const { riderParams, distributionUnitId } = getState().logisticsDispatch;
      if (distributionUnitId) {
        const data = await fetch('/saasmerchant/fsarea/logistics/getriderslist', {
          params: filterNull({
            distributionUnitId,
            ...riderParams,
          }),
          type: 'GET',
        });
        if (data) {
          logisticsDispatch.setState({
            riderList: data.riders || [],
            riderListTotal: data.total || 0,
            riderDesertion: data.desertion,
          });
        }
      }
      logisticsDispatch.setState({ riderListLoading: false });
    },
    // 搜索
    onRiderSearch(riderParams) {
      logisticsDispatch.setState({ riderParams });
    },
    // 底部换页
    onRiderNav(page) {
      const { riderParams } = getState().logisticsDispatch;
      logisticsDispatch.setState({ riderParams: { ...riderParams, page } });
    },
    // 重置筛选项
    onRiderReset() {
      logisticsDispatch.setState({
        riderParams: {
          name: null,
          pageSize: 10,
          page: 1,
        },
      });
    },
    // 批量指派
    async dispatchOrders() {
      const { groupOrderIds, employeeId, dispatchType, distributionUnitId } =
        getState().logisticsDispatch;
      if (groupOrderIds.length === 0) {
        message.error('需先勾选订单，再进行指派');
      } else if (!employeeId) {
        message.error('需先勾选骑手，再进行指派');
      } else {
        const data = await fetch('/saasmerchant/fsarea/logistics/addRider', {
          params: filterNull({
            groupOrderIds,
            employeeId,
            dispatchType,
            distributionUnitId,
          }),
          type: 'POST',
          useJson: true,
        });
        if (data) {
          message.success('批量指派成功');
          logisticsDispatch.setState({
            groupOrderIds: [],
            employeeId: null,
          });
          // logisticsDispatch.getOrderList();
          logisticsDispatch.getRiderList();
        }
        return data;
      }
    },
    setGroupOrderIds(ids) {
      logisticsDispatch.setState({ groupOrderIds: ids });
    },
    setEmployeeId(id) {
      logisticsDispatch.setState({ employeeId: id });
    },
    // 获取商圈全部骑手
    async getAllRiderList() {
      const { distributionUnitId } = getState().logisticsDispatch;
      if (distributionUnitId) {
        const data = await fetch('/saasmerchant/fsarea/logistics/getriderslist', {
          params: filterNull({
            distributionUnitId,
            pageSize: 10000, // 全部骑手
          }),
          type: 'GET',
        });
        if (data) {
          logisticsDispatch.setState({
            allRiderList: data.riders || [],
          });
        }
      }
    },
    // 改派
    async redispatchOrder(params, isBatch) {
      const { dispatchType, groupOrderIds, distributionUnitId } = getState().logisticsDispatch;
      const { groupOrderId, employeeId } = params;
      const data = await fetch('/saasmerchant/fsarea/logistics/addRider', {
        params: filterNull({
          groupOrderIds: isBatch ? groupOrderIds : [groupOrderId],
          employeeId,
          assginType: 1,
          dispatchType,
          distributionUnitId,
        }),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('改派成功');
        // logisticsDispatch.getOrderList();
        logisticsDispatch.getRiderList();
      }
      return data;
    },
  }),
};

export default model;
